/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Sælg eller del ikke mine personlige oplysninger",
      "Bumble Date",
      "Vores apps",
      "Om",
      "Karriere",
      "Kontakt os",
      "Investorer",
      "Shoppen",
      "Virksomheden",
      "Download appen",
      "Tilgængelighed på Bumble",
      "Retningslinjer",
      "Administrer cookies",
      "Modern Slavery act",
      "Meddelelse ved indsamling",
      "Privatlivspolitik",
      "Vilkår og betingelser",
      "Juridisk",
      "Washington Consumer Health Privacy Policy",
      "Scan QR-koden for at hente Bumble-appen",
      "Opsig kontrakter her",
      "Luk menu",
      "Åbn menu",
      "Sprogvalg",
      "Footer",
      "Adgang til Bumble",
      "Apple og Apple-logoet er varemærker tilhørende Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Jobmuligheder",
      "Google Play er et varemærke tilhørende Google LLC.",
      "Retningslinjer",
      "Investorer",
      "Administrer cookies",
      "Modern Slavery Act Statement",
      "Meddelelse ved indsamling",
      "Privatlivspolitik",
      "Sæsonbestemte datingguides",
      "Vilkår & betingelser",
      "Appen",
      "Privatlivspolitik for Consumer Health Data i Washington",
      "Om",
      "Ambassadører",
      "Få nye venner, og find et fællesskab",
      "Skab netværk, og gør fremskridt i din karriere",
      "Find et forhold, noget uforpligtende eller noget derimellem",
      "The Buzz",
      "Se mere",
      "Bliv global med Rejse-tilstand",
      "Date",
      "Funktioner",
      "Compliments",
      "Send Compliments til dem for at gøre dig ekstra bemærket.",
      "Udforsk",
      "En personlig side, der fremhæver de personer, som du har mest tilfælles med, opdateret dagligt.",
      "Inkognito-tilstand",
      "Brug Inkognito-tilstand for at skjule din profil for din chef, familie eller ekskærester.",
      "Match øjeblikkeligt",
      "Fik I gang i samtalen til et fysisk Bumble-event? Fortsæt snakken på appen.",
      "Opening Moves",
      "Vælg Opening Moves for at invitere dit match til at starte chatten, så du ikke behøver at gøre det.",
      "Snooze-tilstand",
      "Sæt dating på pause med Snooze-tilstand. Når du er klar til at date igen, ved du, hvor vi er.",
      "SuperSwipe",
      "Var du vild med profilen? Fortæl dem det med et SuperSwipe.",
      "Rejse-tilstand",
      "Find din rejsesnack, og match over hele verden med Rejse-tilstand.",
      "Videochat",
      "Brug videochat og audioopkald for at se, om I er klar til at mødes i den virkelige verden.",
      "Webapp",
      "Få Bumble-oplevelsen direkte fra din browser.",
      "Gå til Bumble-appen",
      "BFF",
      "Sikkerhed",
      "Historier",
      "Support",
      "Shoppen",
      "Primære",
      "Send komplimenter for at gøre dig ekstra bemærket.",
      "Compliments",
      "Funktioner designet til at skabe ægte, respektfulde og meningsfulde relationer.",
      "Skjul din profil fra din chef, familie eller ekskæreste.",
      "Inkognito-tilstand",
      "Tag en pause fra dating med Snooze-tilstand.",
      "Snooze-tilstand",
      "Er der en, du godt kan lide? Giv besked.",
      "SuperSwipe",
      "Udforsk Date",
      "Pak kufferten, og match hvor som helst.",
      "Rejse-tilstand",
      "Kom så tæt på IRL som muligt uden at tage hjemmefra.",
      "Videoopkald",
      "Vores ambassadører hjælper med at bringe Bumbles værdier ind i fællesskaber over hele landet.",
      "Ambassadører",
      "Funktioner designet til at hjælpe dig med at finde dine personer og skabe kontakt over fællesinteresser.",
      "Organisér et meetup, eller udforsk lokale events i nærheden.",
      "Plans",
      "Udforsk BFF",
      "Al den vejledning og inspiration, du har brug for i din søgen efter kærlighed og venskaber.",
      "Råd og historier til at hjælpe dig med at opbygge ægte venskaber.",
      "Hub for venskaber",
      "Fra Tokyo til Toronto: Udforsk kærlighed fundet på Bumble verden over.",
      "Kærlighedshistorier",
      "Plan den perfekte date – uanset hvornår, hvor og med hvem.",
      "Sæsonbestemte datingguides",
      "Udforsk historier",
      "Læs mere",
      "Bumble på {{social_network}}",
      "Kontakt us",
      "Log ind",
      "(opens in new window)",
      "FAQ",
      "Cookie Policy",
      "Bumble - Blog",
      "Jobmuligheder",
      "Chat",
      "Byer",
      "Administrer Cookies",
      "Copyright © 2006 – til nu. Bumble. Alle rettigheder forbeholdes.",
      "Rapport: Dating med tillid",
      "Apple og Apple-logoet er varemærker tilhørende Apple Inc.{{__EOL__}}Google Play er et varemærke tilhørende Google LLC.",
      "Download",
      "Facebook",
      "Følg os",
      "Help Center",
      "Instagram",
      "Sprog",
      "LinkedIn",
      "Bumble er en del af Inc.",
      "Privatlivspolitik",
      "Safety Centre",
      "Sitemap",
      "Modern Slavery Act statement",
      "Vilkår og betingelser",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dage",
                  "dages"
            ],
            "singular": [
                  "dag",
                  "dags"
            ]
      },
      "hour": {
            "plural": [
                  "timer",
                  "timers"
            ],
            "singular": [
                  "time",
                  "times"
            ]
      },
      "minute": {
            "plural": [
                  "minutter",
                  "minutters"
            ],
            "singular": [
                  "minut",
                  "minuts"
            ]
      },
      "month": {
            "plural": [
                  "måneder",
                  "måneders"
            ],
            "singular": [
                  "måned",
                  "måneds"
            ]
      },
      "second": {
            "plural": [
                  "sekunder",
                  "sekunders"
            ],
            "singular": [
                  "sekund",
                  "sekunds"
            ]
      },
      "year": {
            "plural": [
                  "år",
                  "årenes"
            ],
            "singular": [
                  "år",
                  "årets"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
